import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validates emails and requires a top-level domain (e.g. .com, .com.br, .net)
// Allows multiple dot parts in the TLD (e.g. .co.uk, .com.br)
const EMAIL_TLD_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})*$/;

export function emailWithTldValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null; // leave required validation to Validators.required
    }
    const valid = EMAIL_TLD_REGEX.test(String(value).trim());
    return valid ? null : { emailTld: true };
  };
}

export default emailWithTldValidator;
